export default __webpack_public_path__ + "static/media/arrowRight.65a34a0c.svg";